import React from "react"
import { Image } from "react-bootstrap"

export default function ({ imageSrc, description, url }) {
  return (
    <div>
      <a href={url}>
        <Image src={imageSrc} alt={description} rounded />
      </a>
    </div>
  )
}
